import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper } from "@mui/material";

interface BalanceTableProps {
  investmentBalance: number;
  loanBalance: number;
  cashBalance: number;
  outOfBalance: number;
}

const BalanceTable: React.FC<BalanceTableProps> = ({
  investmentBalance,
  loanBalance,
  cashBalance,
  outOfBalance,
}) => {
  const formatCurrency = (value: number) => {
    if (value !== null && value !== undefined) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(value);
    }
  };

  return (
    <TableContainer component={Paper}
      elevation={0}
      sx={{
        display: "inline-block",
        margin: "auto",
        padding: 1,
        width: "fit-content"
      }}
    >
      <Table
        size="small"
        sx={{
          border: "none",
          width: "auto",
          tableLayout: "auto",
          maxWidth: "100%",
        }}
      >
        <TableBody>
          <TableRow key="investment-balance-row">
            <TableCell component="th" scope="row" sx={{ borderBottom: "none", whiteSpace: "nowrap" }}>
              Investment Balance:
            </TableCell>
            <TableCell align="right" sx={{ borderBottom: "none", whiteSpace: "nowrap" }}>
              {formatCurrency(investmentBalance)}
            </TableCell>
          </TableRow>

          <TableRow key="loan-balance-row">
            <TableCell component="th" scope="row" sx={{ borderBottom: "none", whiteSpace: "nowrap" }}>
              Loan Balance:
            </TableCell>
            <TableCell align="right" sx={{ borderBottom: "none", whiteSpace: "nowrap" }}>
              {formatCurrency(loanBalance)}
            </TableCell>
          </TableRow>

          <TableRow key="cash-balance-row">
            <TableCell component="th" scope="row" sx={{ borderBottom: "none", whiteSpace: "nowrap" }}>
              Cash Balance:
            </TableCell>
            <TableCell align="right" sx={{ borderBottom: "none", whiteSpace: "nowrap" }}>
              {formatCurrency(cashBalance)}
            </TableCell>
          </TableRow>

          <TableRow key="out-of-balance-row">
            <TableCell component="th" scope="row" sx={{ borderBottom: "none", whiteSpace: "nowrap" }}>
              Out of Balance:
            </TableCell>
            <TableCell align="right" sx={{ borderBottom: "none", whiteSpace: "nowrap" }}>
              {formatCurrency(outOfBalance)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BalanceTable;
